import { render, staticRenderFns } from "./DeleteProductFromStock.vue?vue&type=template&id=0b7f0c16&scoped=true"
import script from "./DeleteProductFromStock.vue?vue&type=script&lang=js"
export * from "./DeleteProductFromStock.vue?vue&type=script&lang=js"
import style0 from "./DeleteProductFromStock.vue?vue&type=style&index=0&id=0b7f0c16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7f0c16",
  null
  
)

export default component.exports